import { render } from "./Page-schematics.vue?vue&type=template&id=6e58986c&scoped=true"
import script from "./Page-schematics.vue?vue&type=script&lang=js"
export * from "./Page-schematics.vue?vue&type=script&lang=js"

import "./Page-schematics.vue?vue&type=style&index=0&id=6e58986c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e58986c"]])

export default __exports__